module.exports = __webpack_public_path__ + "./assets/apple-badge.svg";